import React, { useState } from "react";
import { motion } from "framer-motion";
// import about1 from "../assets/about1.jpg"
import company from "../assets/company.jpg"
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoIosVideocam } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import N3060 from "../assets/N3060.mp4";

const About1 = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <section className="w-full bg-white py-16 px-6 md:px-12 xl:px-20">
      <motion.div
        className="container mx-auto flex flex-col lg:flex-row items-center gap-8"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        whileHover={{ scale: 1 }} // small zoom effect on hover
      >
        {/* Left Image */}
        <motion.div
          className="relative w-full lg:w-1/2 cursor-pointer group"
          whileHover={{ scale: 1.0, }}
          // transition={{ type: "spring", stiffness: 200 }}
          onClick={() => setIsVideoOpen(true)}
        >
          <img
            src={company}
            alt="Firefighter"
            className="rounded-2xl shadow-lg w-full h-full object-cover"
          />

          <button
            onClick={() => setIsVideoOpen(true)}
            className="absolute top-4 right-4 md:top-6 md:right-6 bg-black/70 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-black/80 transition-all duration-300 transform hover:scale-110 hover:shadow-2xl"
          >
            <IoIosVideocam className="text-2xl md:text-3xl" />
          </button>
        </motion.div>

        {/* VIDEO MODAL */}
        {isVideoOpen && (
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-4">
            <div className="relative w-full max-w-3xl">
              <video
                controls
                autoPlay
                className="w-full rounded-xl shadow-2xl"
              >
                <source src={N3060} type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              <button
                onClick={() => setIsVideoOpen(false)}
                className="absolute -top-5 -right-5 bg-green-600 text-white w-12 h-12 rounded-full flex items-center justify-center hover:bg-red-600 transition-all shadow-xl"
              >
                <IoMdClose className="text-2xl" />
              </button>
            </div>
          </div>
        )}

        {/* Right Content */}
        <motion.div
          className="w-full lg:w-1/2 space-y-6"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.02 }}
        >
          {/* Heading */}
          <div>
            <h3 className="text-green-700 uppercase font-semibold tracking-wider text-lg mb-2">
              About Us
            </h3>
            <h2 className="text-2xl xl:text-3xl font-semibold leading-snug -mb-1">
              Nohmi Bosai: Safeguarding Lives With Trusted Fire Protection
            </h2>
          </div>

          {/* Experience + Description */}
          <div>
            <h4 className="text-green-700 font-semibold text-lg ">
              Over 18+ Years of Experience Serving in this Industry in India
            </h4>
            <p className="text-gray-700 mt-5 leading-relaxed text-md text-justify">
              At Nohmi Bosai, we provide world-class fire protection systems and equipment trusted across industries worldwide.
              From advanced smoke detection to reliable fire suppression, our solutions are designed to safeguard lives and assets
              with unwavering dependability.
            </p>
            <p className="text-gray-700 mt-3 leading-relaxed text-md text-justify">
              But our mission goes beyond technology. At Nohmi Bosai (India), we don’t just supply fire protection system—we deliver peace of mind. Built on a foundation of reliability, innovation, and unwavering commitment to safety, our mission is to empower communities, industries, and first responders with tools they can trust when it matters most.
            </p>
          </div>

          {/* Learn More Button */}
          <motion.div whileHover={{ scale: 1.1 }}>
            <Link
              to="/about"
              className="bg-green-700 text-white px-5 py-3 rounded-md shadow-md inline-flex items-center gap-2 
             hover:bg-green-800 transition text-base md:text-lg font-semibold"
            >
              <span>Learn More</span>
              <FaArrowRight className="text-lg" />
            </Link>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default About1;

